/** Tailwind default hex literals for Recharts fill/stroke props. */
export const CHART_COLOR = {
  blue600: "#2563eb",
  blue500: "#3b82f6",
  blue400: "#60a5fa",
  emerald600: "#059669",
  emerald500: "#10b981",
  emerald400: "#34d399",
  red500: "#ef4444",
} as const;

export const DEFAULT_CHART_PALETTE = [
  CHART_COLOR.blue600,
  CHART_COLOR.blue500,
  CHART_COLOR.blue400,
  CHART_COLOR.emerald600,
  CHART_COLOR.emerald500,
  CHART_COLOR.emerald400,
];

const SEMANTIC_CHART_COLORS: Record<string, string> = {
  passed: CHART_COLOR.emerald500,
  failed: CHART_COLOR.red500,
};

function normalizeChartColorKey(name: string): string {
  return name.trim().toLowerCase();
}

/**
 * Resolve a series or slice color. Known status names (`passed`, `failed`)
 * map to semantic colors; everything else uses the default palette by index.
 *
 * Stored `series[].color` values in dashboard YAML are ignored until the panel
 * editor exposes an intentional color picker.
 */
export function resolveChartColor(name: string, paletteIndex: number): string {
  const semantic = SEMANTIC_CHART_COLORS[normalizeChartColorKey(name)];
  if (semantic) return semantic;
  return DEFAULT_CHART_PALETTE[paletteIndex % DEFAULT_CHART_PALETTE.length]!;
}
